import { ElowenApiError } from './elowenClient';
import type { ConfigSnapshot } from './types';

/** The current snapshot a `PUT /config` revision conflict carries, or undefined when the error is not one.
 *  The one recognition of that answer: 409 with the daemon's current snapshot in `details.current` and a numeric
 *  revision. Any other 409 (a confirmation that is required, a row that is already readable) is not a lost
 *  revision. The cache adoption of the snapshot and Settings' conflict recovery both read it from here. */
export function configConflictSnapshot(error: unknown): ConfigSnapshot | undefined {
  if (!(error instanceof ElowenApiError) || error.status !== 409) return undefined;
  const current = error.details?.current;
  if (typeof current !== 'object' || current === null || Array.isArray(current)) return undefined;
  return typeof (current as { revision?: unknown }).revision === 'number' ? current as ConfigSnapshot : undefined;
}

export function isConfigRevisionConflict(error: unknown): error is ElowenApiError {
  return configConflictSnapshot(error) !== undefined;
}
